<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <div class="row">
                <div class="col-xs-9">
                    <h5>
                        Material Overdue
                    </h5>
                </div>

                <div v-if="!loading" style="margin-top: 4px">
                    <div class="col-xs-5">
                        <select-widget
                                v-model="horizon"
                                class="form-control input-sm"
                                :nullable="true"
                                placeholder="(today)"
                                :options="horizonOptions"
                        ></select-widget>
                    </div>

                    <div class="col-xs-5">
                        <select-widget
                                v-model="portal"
                                class="form-control input-sm"
                                :nullable="true"
                                placeholder="(all portals)"
                                :options="portalOptions"
                        ></select-widget>
                    </div>

                    <div class="col-xs-5">
                        <select-widget
                                v-model="channel"
                                class="form-control input-sm"
                                :nullable="true"
                                placeholder="(all channels)"
                                :options="channelOptions"
                        ></select-widget>
                    </div>
                </div>
            </div>
        </div>

        <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

        <ul v-else class="list-group">
            <li v-for="(ad, index) in ads.data" class="list-group-item" style="padding: 10px 0">
                <div style="display: flex; flex-direction: row">
                    <div
                            class="text-muted"
                            style="flex: 1; font-size: 24px; display: flex; justify-content: center; align-items: center;"
                    >
                        <i class="fa fa-bullhorn"></i>
                    </div>

                    <div style="flex: 7 1 0%;">
                        <router-link :to="getLink(ad)">
                            {{ ad.order.company.name }}
                        </router-link>

                        <i v-if="ad.dtp_comment" class="fa fa-comment" v-tooltip="ad.dtp_comment"></i>

                        <i v-else class="fa fa-comment" style="opacity: 0.2"></i>

                        <br>

                        {{ ad.name }} &middot; {{ ad.channel.name }} ({{ ad.portal.name }})
                    </div>

                    <div style="flex: 1; font-size: 24px; display: flex; justify-content: flex-end; align-items: center;">
                        <button type="button" class="btn btn-lg" @click="$router.push(getLink(ad))" style="background-color: #ffffff">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </li>

            <li v-if="ads.meta.total > 10" class="list-group-item" style="padding: 10px 0">
                <pager :pagination="ads.meta" @navigate="navigate"></pager>
            </li>

            <li v-if="ads.data.length === 0" class="list-group-item text-center" style="padding: 50px;">
                <i class="fa fa-glass-cheers" style="font-size: 96px;"></i>

                <br><br>

                You have no ads missing content!
            </li>
        </ul>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import moment from 'moment'
    import notify from '@/notify'
    import store from '@/store'
    import Load from '@/mixins/Load'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'
    import Pager from '@/components/Lists/Pager'
    import SaveHeight from '@/mixins/SaveHeight'
    import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

    export default {
        components: {LoadingSpinner, Pager, SelectWidget},

        mixins: [Load, SaveHeight],

        data() {
            return {
                ads: null,
                shared: store,
                horizon: null,
                portal: null,
                channel: null,
                page: 1,
                portals: null,
                channels: null
            }
        },

        watch: {
            horizon() {
                this.page = 1

                this.fetch()
            },

            portal() {
                this.page = 1

                this.channel = null

                this.fetch()
            },

            channel() {
                this.page = 1

                this.fetch()
            }
        },

        mounted() {
            this.load({
                ads: '/api/v1/ads?page_size=10&content=&page=' + this.page + '&content-deadline-before=' + this.date,
                portals: '/api/v2/portals',
                channels: '/api/v1/channels'
            })
        },

        computed: {
            date() {
                return moment().add(this.horizon, 'day').format('YYYY-MM-DD')
            },

            horizonOptions() {
                return [
                    {value: 1, label: '+1 days'},
                    {value: 2, label: '+2 days'},
                    {value: 3, label: '+3 days'},
                    {value: 7, label: '+7 days'},
                    {value: 14, label: '+14 days'},
                    {value: 30, label: '+30 days'}
                ]
            },

            portalOptions() {
                return this.portals.data.map(portal => {
                    return {
                        value: portal.id,
                        label: portal.attributes.name
                    }
                })
            },

            channelOptions() {
                return this.filteredChannels.map(channel => {
                    return {
                        value: JSON.stringify({id: channel.id, type: channel.type}),
                        label: channel.name + ' (' + channel.portal.name + ')'
                    }
                })
            },

            filteredChannels() {
                return this.channels.data.filter(channel => {
                    return this.portal ? channel.portal_id === parseInt(this.portal) : true
                })
            },

            channelId() {
                if (!this.channel) {
                    return ''
                }

                return JSON.parse(this.channel).id
            },

            adType() {
                if (!this.channel) {
                    return ''
                }

                if (JSON.parse(this.channel).type === 'time-based-channels') {
                    return 'time-based-ads'
                }

                if (JSON.parse(this.channel).type === 'publication-based-channels') {
                    return 'publication-based-ads'
                }
            }
        },

        methods: {
            fetch() {
                this.saveHeight()

                this.load({
                    ads: '/api/v1/ads?page_size=10&content=&page=' + this.page + '&content-deadline-before=' + this.date + '&portal=' + (this.portal ? this.portal : '') + '&type=' + this.adType + '&channel=' + this.channelId
                })
            },

            navigate(page) {
                this.page = page

                this.fetch()
            },

            getLink(ad) {
                return '/companies/' + ad.order.company.id + '/orders/' + ad.order.id + '/' + ad.type + '/' + ad.id
            },

            saveHeight() {
                if (this.$el.querySelector('.list-group')) {
                    this.height = this.$el.querySelector('.list-group').clientHeight
                }
            }
        }
    }
</script>